import React  from 'react';
import { RydMixer } from '../../audio/mixer';
import { useMixerStore } from '../../stores/MixerStore';
import './instruments/Common.css';
import './RydAudioMixer.css';
import './TrackControl.css';
import { VolumeMeter } from './VolumeMeter';
import { normalizeClassName } from '../../render/renderUtils';
import { TrackColor } from '../../render/trackColor';
import { RydInstrument } from '../../model/instrument';
import { TrackOutputTypeIndicator } from '../dialogs/InstrumentSelectionDialog';
import { RydToggleButton } from '../widgets/RydToggleButton';
import { RydDial } from '../widgets/data-input/RydDial';


export function TrackControl({
  channelNumber = -1,
  track,
  onUpdate,
  trackColor = TrackColor.DEFAULT_COLOR,
  output
}: {
  channelNumber?: number,
  track: RydMixer.TrackInitParams,
  onUpdate: (id: number, changes: Partial<RydMixer.TrackParams>) => void,
  trackColor?: TrackColor.Color,
  output? : RydInstrument
}) {

  const mixerStore = useMixerStore();
  const mixer = mixerStore.mixer;

  if (!mixer) {
    return <div>Error: Mixer is not initialized</div>;
  }

  return (
    <div
      className={normalizeClassName(['ryd-audio-mixer-track', 'ryd-instrument-wrapper'])}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        padding: '2px',
      }}>
      <button className='track-heading'
        style={{
          backgroundColor: trackColor,
        }}>
        &nbsp;
      </button>
      <h3 style={{
        borderBottom: `1px solid ${trackColor}`,
        borderLeft: `1px solid ${trackColor}`,
        borderRight: `1px solid ${trackColor}`,
        marginTop: '0px',
      }}>
        <b>{channelNumber}</b>: {track.id}
      </h3>
      <TrackOutputTypeIndicator output={output} />
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around',
      marginTop: '2px',
       }}>
        <label>
          {/* Gain */}
          <input
            className="vertical"
            type="range"
            min={0}
            max={1}
            step={0.01}
            value={track.gain}
            onChange={e => onUpdate(track.id, { gain: parseFloat(e.target.value) })}
          />

        </label>
        <VolumeMeter audioNode={track.sourceNode} />
      </div>
      <label>
        {/* Pan */}
        <RydDial
          min={-1}
          max={1}
          initialValue={track.pan}
          update={value => onUpdate(track.id, { pan: value })}
          label={"Pan"}
        />
      </label>
      <div style={{ width: '100%', display: 'inline-flex', alignItems: 'center', justifyContent: 'space-around' }}>
        <MuteToggleButton
          active={track.muted}
          onActivate={() => onUpdate(track.id, { muted: true })}
          onDeactivate={() => onUpdate(track.id, { muted: false })}
          activeStyle={{ backgroundColor: 'orange' }}
          inactiveStyle={{ backgroundColor: 'lightgray' }}
        />
        <SoloToggleButton
          active={track.solo}
          onActivate={() => onUpdate(track.id, { solo: true })}
          onDeactivate={() => onUpdate(track.id, { solo: false })}
          activeStyle={{ backgroundColor: 'cyan' }}
          inactiveStyle={{ backgroundColor: 'lightgray' }}
        />
      </div>
    </div>
  );
}

export function SoloToggleButton({
  active,
  onActivate,
  onDeactivate,
  activeStyle,
  inactiveStyle,
  children
}: {
  active: boolean,
  onActivate: () => void,
  onDeactivate: () => void,
  activeStyle?: React.CSSProperties,
  inactiveStyle?: React.CSSProperties,
  children?: React.ReactNode
}) {
  return (<RydToggleButton
    active={active}
    onActivate={onActivate}
    onDeactivate={onDeactivate}
    activeStyle={activeStyle}
    inactiveStyle={inactiveStyle}
  >S</RydToggleButton>
  );
}

export function MuteToggleButton({
  active,
  onActivate,
  onDeactivate,
  activeStyle,
  inactiveStyle,
  children
}: {
  active: boolean,
  onActivate: () => void,
  onDeactivate: () => void,
  activeStyle?: React.CSSProperties,
  inactiveStyle?: React.CSSProperties,
  children?: React.ReactNode
}) {
  return (<RydToggleButton
    active={active}
    onActivate={onActivate}
    onDeactivate={onDeactivate}
    activeStyle={activeStyle}
    inactiveStyle={inactiveStyle}
  >M</RydToggleButton>
  );
}